'use client';
import { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import { usePathname, useSearchParams } from 'next/navigation';
import { useClickOutside } from '@overlapdev/hooks';
import { updateSearchParams } from '@overlapdev/functions';
import { TaxonomyTermType } from '@overlapdev/types';
import { ArrowDownSVG, ArrowUpSVG } from 'components/svg';

const BlogFilters = ({ categories }: { categories?: TaxonomyTermType[] }) => {
	//__Refs
	const wrapperRef = useRef(null);

	//__Hooks
	const pathname = usePathname();
	const searchParams = useSearchParams();
	const clickOutside = useClickOutside(wrapperRef);

	//__State
	const [category, setCategory] = useState(0);
	const [open, setOpen] = useState(false);

	//__Use Effect

	//Update filters state if searchParams present
	useEffect(() => {
		const category_param = searchParams.has('cat') ? parseInt(searchParams.get('cat') || '', 10) : 0;
		if (category_param) {
			setCategory(category_param);
		}
	}, [searchParams]);

	useEffect(() => {
		if (clickOutside) {
			setOpen(false);
		}
	}, [clickOutside]);

	//__Functions
	const toggle = (term_id: number) => {
		setOpen(false);
		setCategory(term_id);
		window.history.pushState(null, '', `${pathname}?${updateSearchParams(searchParams.toString(), 'cat', term_id === 0 ? '' : term_id.toString(), 'p')}`);
	};

	return categories?.length ? (
		<div className='relative max-md:mb-2 sm:w-[270px]' ref={wrapperRef}>
			<span className='block mb-2 text-sm'>Category</span>
			<div className={`bg-white border border-grey cursor-pointer flex font-semibold gap-4 items-center justify-between leading-none py-[13px] pl-5 pr-3 rounded-full`} onClick={() => setOpen(!open)}>
				<div className='overflow-hidden whitespace-nowrap w-[82%]'>{category !== 0 ? <span>{parse(categories.find((e) => parseInt(e.term_id.toString(), 10) === parseInt(category.toString(), 10))?.name || '')}</span> : <span>All Categories</span>}</div>
				<div className='opacity-60 text-black'>{open ? <ArrowUpSVG width={12} /> : <ArrowDownSVG width={12} />}</div>
			</div>
			<div className={`absolute bg-white left-0 min-w-full overflow-hidden pr-0.5 rounded-3xl shadow-[0px_20px_30px_0px_rgba(0,0,0,0.15)] top-full transition-ease w-full z-10 ${open ? 'max-h-62 py-5' : 'max-h-0'}`}>
				<div className='flex flex-col gap-2 max-h-52 overflow-auto'>
					<div>
						<input className='hidden' type='checkbox' id='term_0' name='blog_category' value={0} checked={category === 0} onChange={() => toggle(0)} />
						<label className={`block cursor-pointer font-semibold px-6 whitespace-nowrap hover:text-grey ${category === 0 ? ' text-dark-blue' : ''}`} htmlFor='term_0'>
							All Categories
						</label>
					</div>
					{categories?.map(
						(term) =>
							term.count > 0 && (
								<div key={`term_${term.term_id}`}>
									<input className='hidden' type='checkbox' id={`term_${term.term_id}`} name='blog_category' value={term.term_id} checked={category === term.term_id} onChange={() => toggle(term.term_id)} />
									<label className={`block cursor-pointer font-semibold px-6 whitespace-nowrap hover:text-grey ${category === term.term_id ? ' text-primary' : ''}`} htmlFor={`term_${term.term_id}`}>
										{parse(term.name)}
									</label>
								</div>
							)
					)}
				</div>
			</div>
		</div>
	) : null;
};

export default BlogFilters;
